<div class="flex min-h-screen w-full" [ngClass]="[(currentStep! >= 3) ? 'flex-row-reverse' : '', (currentStep == 4 && selectedOptionPageFour === 'upload') ? 'mobile:flex-col-reverse' : '']">

    <div class="w-1/2 flex flex-col mobile:w-full" [ngClass]="[(currentStep == 4 && selectedOptionPageFour === 'upload') ? 'bg-neutral-100' : 'bg-primary-800', 
        (currentStep == 4 && selectedOptionPageFour === 'upload') ? '' : 'mobile:hidden'
     ]">
        <div class="flex-grow flex justify-end items-end" *ngIf="currentStep != 4 || selectedOptionPageFour !== 'upload'">
            <img src="assets/images/signup-page/dashboard-example.png" alt="{{ 'auth.dashboard_example_image' | transloco}}"
                class="w-[80%] max-w-[1440px] h-auto max-h-[960px] pointer-events-none select-none" />
        </div>
        <div class="flex-grow flex flex-col justify-center items-center" *ngIf="currentStep == 4 && selectedOptionPageFour === 'upload'">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-6 mobile:max-w-[90vw]">
                <app-onboarding-step-four-upload></app-onboarding-step-four-upload>
            </div>
        </div>

    </div>

    <div class="bg-white p-4 z-50 px-[5%] w-1/2 flex flex-col mobile:px-7 mobile:w-screen">
        <div class="flex w-full items-center justify-between mobile:justify-center mobile:flex-col mobile:gap-2 mobile:mt-2">
            <app-logo></app-logo>
            <p class="font-normal text-black">{{ 'shared.step' | transloco}} {{currentStep}}/5. {{ localizedStepInfoArray[currentStep!-1] }}</p>
        </div>

        <div class="flex-grow flex flex-col justify-center items-center">
            <div class="max-w-screen-sm w-full self-center mt-[5vh] mobile:mt-6">
                <ng-container [ngSwitch]="currentStep">
                    <app-onboarding-step-one *ngSwitchCase="1"></app-onboarding-step-one>
                    <app-onboarding-step-two *ngSwitchCase="2"></app-onboarding-step-two>
                    <app-onboarding-step-three *ngSwitchCase="3"></app-onboarding-step-three>
                    <app-onboarding-step-four *ngSwitchCase="4" [(selectedOption)]="selectedOptionPageFour"></app-onboarding-step-four>
                    <div *ngSwitchDefault>{{ 'auth.onboarding_page.invalid_step' | transloco}}</div>
                </ng-container>



            </div>

        </div>
    </div>


</div>